import {Component} from '@angular/core';
import {AbstractTopicModalComponent} from '../abstract-topic-modal/abstract-topic-modal.component';

/**
 * Class for the SecondaryTopicModalComponent
 * @class SecondaryTopicModalComponent
 *
 * @description Implementation for the SecondaryTopicModalComponent. Defines multiple as true to use checkbox inputs
 *
 * @usage
 * To be used with a [ModalController]{@link https://ionicframework.com/docs/api/components/modal/ModalController/} create call
 * ```ts
 *
 * const modal = this.modalController.create(
 *    SecondaryTopicModalComponent,
 *    { choices: this.choices, value: this.value }:
 *    {
 *      choices: TreeNode[],
 *      value: TreeNode[]
 *    },
 *    {}: ModalOptions);
 * modal.onDidDismiss((data) => this.hModalDismiss(data))
 * modal.present();
 * ```
 */
@Component({
  selector: 'advtech-secondary-topic-modal',
  templateUrl: '../abstract-topic-modal/abstract-topic-modal.component.html',
})
export class SecondaryTopicModalComponent extends AbstractTopicModalComponent {
  /**
   * Label for the modal
   * @type {string}
   */
  title: string = 'Secondary Topics';

  /**
   * Tells the modal to use checkbox inputs
   * @type {boolean}
   */
  multiple: boolean = true;
}


// WEBPACK FOOTER //
// ./src/app/shared/components/metadata-menu/topic/secondary-topic-modal/secondary-topic-modal.component.ts